import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Tooltip, Button, Image, Typography } from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { Helmet } from "react-helmet";
import drive7Icon from "../../src/assets/images/drive7.ico";
import awtlIcon from "../../src/assets/images/awtl.ico";
import starlingIcon from "../../src/assets/images/starling.ico";
import secureIcon from '../../src/assets/images/secure.ico';
import { DeleteFilled } from "@ant-design/icons";
const { Title } = Typography;
class DistributorOptionsMain extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    // this.mapShow = Number(
    //   JSON.parse(JSON.stringifythis.cookies.get("mapShow"))
    // );
    this.state = {
      name: '',
      storedUserType:''
    };
    this.showLaunchingItems = {
      livetracking: false,
      dashboard: false,
      historytracking: false,
      detailtracking: false,
      parentalertreportlist: false,
      master: false,
      AdvanceDashboard: false,
      vehiclelist: false,
      parentreport: false,
      maintenancedashboard: false,
      showHelpModal: false,
      showLaunchingDashboard: 2,
    };
    // console.log(this.mapShow);


  }

  componentDidMount() {
    const data = JSON.parse(base64_decode(this.cookies.get("data")));
    const storedUserType = parseInt(localStorage.getItem("originalUserType"));

    this.setState({ name: data.userName,storedUserType: storedUserType});
  }
  updateDashboard = (value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    decodedCookieData.showLaunchingDashboard = value;
    console.log(decodedCookieData, "decoded cookidata");
    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    //this.setState({ update: 1 });
  };

  updateIcons = () => {
    if (conf.project === "drive7") {
      return {
        favicon: drive7Icon,
        appleTouchIcon: drive7Icon,
      };
    } else if (conf.project === "awtltrack") {
      return {
        favicon: awtlIcon,
        appleTouchIcon: awtlIcon,
      };
    } else if (conf.project === "starlingeye") {
      return {
        favicon: starlingIcon,
        appleTouchIcon: starlingIcon,
      };
    } else if (conf.project === "trackeazy") {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    } else if (conf.project === "securetrack") {
      return {
        favicon: secureIcon,
        appleTouchIcon: secureIcon,
      };
    } else {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    }
  };

  updateTitle = () => {
    if (conf.project === "drive7") {
      return "Drive7";
    } else if (conf.project === "awtltrack") {
      return "AWTL";
    } else if (conf.project === "starlingeye") {
      return "Starlingeye";
    } else if (conf.project === "trackeazy") {
      return "Trackeazy";
    } else if (conf.project === "securetrack") {
      return "SecureTrack";
    } else {
      return "Trackeazy";
    }
  };

  handleRedirect = (dashboardType, path) => {
    this.updateDashboard(dashboardType);
    this.props.navigate(path);
  };


  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };
    const { favicon, appleTouchIcon } = this.updateIcons();

    return (
      <>
        <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>


        <div className="distapp-container">
          <div className="login-overlay">
            {/* Logo Section */}
            <div className="container mt-4" style={{ textAlign: 'center', display: 'flex' }}>
              <div className="text-start">
                <i
                  class="bi bi-arrow-left-circle"
                  style={{
                    color: "white",
                    fontSize: "25px",
                    marginInlineStart: "25px",
                  }}
                  onClick={async () => {
                    if (this.state.storedUserType == 8) {
                      this.props.navigate("/DistributorsLogin")
                    }
                    else {
                      this.props.navigate("/SecureTrackLogin")
                    }
                  }}
                ></i>
              </div>
              <Image
                src={require('../assets/images/swd-dashboard-st.png')}
                alt="SecureTrackX"
                preview={false}
                className="mainLogo w-100"
              />
              <div className=""></div>
            </div>

            <Title level={5} className="white-text distributor-title-main" style={{ marginBottom: '5px', color: 'white' }}>
              {this.state.name}
            </Title>

            {/* Login Circles */}
            <div className="distlogin-section">
              {/* SecurePath Circle */}
              <div className="d-flex gap-5">
                <div className="distmaincircle login-circle"
                  onClick={() => this.props.navigate("/DistributorCertificate")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="distmainbgblack text-center">
                    <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                      CERTIFICATE
                    </Title>

                  </div>
                </div>


                <div className="distmaincircle login-circle"
                  onClick={() => this.props.navigate("/DistributorCredits")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="distmainbggreen text-center">
                    <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                      CREDITS
                    </Title>

                  </div>
                </div>


                {/* SecureTrack Basic Circle */}
                <div className="distmaincircle login-circle"
                  onClick={() => this.handleRedirect(0, "/vehiclelist/7")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="distmainbred text-center">
                    <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                      NON CERTIFICATES
                    </Title>

                  </div>
                </div>
              </div>

              <div className="d-flex gap-5">
                <div className="distmaincircle login-circle"
                  onClick={() => this.handleRedirect(0, "/livetracking")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="distmainbgwhite text-center">
                    <Title level={5} className="white-text" style={{ marginBottom: '5px', }}>
                      MONITOR
                    </Title>

                  </div>
                </div>


                <div className="distmaincircle login-circle"
                  onClick={() => this.handleRedirect(0, "/detailtracking/NoData")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="distmainbgwhite text-center">
                    <Title level={5} className="white-text" style={{ marginBottom: '5px', }}>
                      OFFLINE
                    </Title>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
DistributorOptionsMain.contextType = StoreContext;
export default observer(withRouter(DistributorOptionsMain));
